var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-action-bar-items',{class:[
		_vm.$s.ActionBar,
		_vm.$s[("position_" + _vm.position)],
		_vm.$s[("hide-on_" + _vm.hideOn)] ],attrs:{"tag":"div"}},[_c('vnode-syringe',{attrs:{"class&":_vm.$s.Action}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }